<section class="reviews" [id]="review.id">

  <div class="container">

    <div class="section-header">

      <span class="subtitle">
        {{ review.subtitle }}
      </span>

      <h2>
        {{ review.title }}
      </h2>

    </div>

    <div class="review-grid">

      @for (review of review.reviews; track review.author) {
      <div class="review-card">

        <div class="stars">

          @for (star of [].constructor(review.rating); track $index) {
          <i class="fas fa-star"></i>
          }

        </div>

        <p class="review-text">
          "{{ review.review }}"
        </p>

        <h4>
          – {{ review.author }}
        </h4>

      </div>
      }

    </div>

  </div>

</section>
